// Generated by purs version 0.13.0
"use strict";
var Data_Ord = require("../Data.Ord/index.js");
var takeDamage = function (damage) {
    return function (v) {
        return {
            maxHp: v.maxHp,
            hp: v.hp - damage | 0,
            defense: v.defense,
            power: v.power
        };
    };
};
var heal = function (amount) {
    return function (v) {
        return {
            maxHp: v.maxHp,
            hp: Data_Ord.min(Data_Ord.ordInt)(v.maxHp)(v.hp + amount | 0),
            defense: v.defense,
            power: v.power
        };
    };
};
module.exports = {
    takeDamage: takeDamage,
    heal: heal
};
